module.exports = __webpack_public_path__ + "static/media/travel18.cd5717c6.jpg";